import React from "react";
// import { HtmlTooltip } from "../../molecules/tooltip";
import { Box, Stack, Typography } from "@mui/material";
import useMediaQuery from "@mui/material/useMediaQuery";
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined";
import CloseIcon from "@mui/icons-material/Close";

import { HtmlTooltip, Section } from "@arp/react-ndbx";

function LabelTooltip({
  labelHeading,
  controlIdentifier,
  tooltipTitle,
  useLightVersion = false,
  bottomMargin = 0.5,
  iconSize = 24,
  zIndex = 0,
  ml = { xs: 1, md: 0 },
  mt = { xs: 0, md: 0.5 },
  headingVariant = "allianzLabelMedium",
  stackWidth = "initial",
  additionalText = null,
  ...other
}) {
  // Check if we are less than sm, if so move the tooltip
  // placement above the icon
  const matches = useMediaQuery("(min-width:600px)");
  const placement = matches === true ? "right" : "bottom-start";

  return (
    <Stack
      sx={{
        justifyContent: { xs: "center", md: "flex-start" },
        zIndex: { zIndex },
      }}
      id={controlIdentifier}
    >
      <Stack direction="row" alignItems="center" width={stackWidth}>
        <Section xs={7} md={12} justifyContent="center">
          <Typography
            data-identifier={`${controlIdentifier}-label`}
            variant={headingVariant}
          >
            {labelHeading}
          </Typography>
        </Section>
        <Box ml={1} pt={0} mb={bottomMargin} sx={{ lineHeight: 0 }}>
          <HtmlTooltip
            width={`calc(100vw - 40px)`}
            title={
              <>
                <CloseIcon
                  sx={{ float: "right", mt: "-8px", fontSize: "14px" }}
                ></CloseIcon>
                <div
                  dangerouslySetInnerHTML={{
                    __html: tooltipTitle || "PLEASE ADD TOOLTIP TEXT!",
                  }}
                />
              </>
            }
            placement={placement}
          >
            {/* A span is required around a custom svg to ensure that the Tooltip work */}
            <span>
              {useLightVersion ? (
                <ErrorOutlineOutlinedIcon
                  data-identifier={`${controlIdentifier}-icon`}
                  sx={{
                    width: iconSize,
                    height: iconSize,
                    mt: mt,
                    ml: ml,
                  }}
                />
              ) : (
                <ErrorOutlineOutlinedIcon
                  data-identifier={`${controlIdentifier}-icon`}
                  sx={{
                    width: iconSize,
                    height: iconSize,
                    mt: mt,
                    ml: ml,
                  }}
                />
              )}
            </span>
          </HtmlTooltip>
        </Box>
      </Stack>
    </Stack>
  );
}

export default LabelTooltip;
